import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

const GET_TICKET_TEMPLATES = gql`
  query GetTicketTemplates($account_id: Int!) {
    getTicketTemplates(account_id: $account_id) {
      id
      name
      type
      price
      track_price
      description
      description_video
      description_image_id
      fee_dollar
      fee_percent
      pos_fee_dollar
      pos_fee_percent
      limit
      visibility
      reserved_seat
      reserved_seat_category
      reserved_seat_prefix
      reserved_seat_section
      category_id
      chart_id
      set_member_number
      prefix_text
      suffix_text
      last_member_number
      windows {
        id
        name
        ends
        time
        price
        tiers {
          id
          name
          price
          track_price
        }
      }
      tiers {
        id
        name
        price
        track_price
      }
      pages {
        id
        name
        pdf_url
        video_url
        pdf_id
        form_id
        order
        waivers {
          id
          waiver_id
        }
      }
    }
  }
`;

/**
 * Hook to fetch ticket templates for a given account
 * @param {number|string} accountId - The account ID to fetch templates for
 * @returns {Object} - { templates, loading, error, refetch }
 */
export function useTicketTemplates(accountId) {
  const id = accountId ? Number(accountId) : null;

  const { data, loading, error, refetch } = useQuery(GET_TICKET_TEMPLATES, {
    variables: { account_id: id },
    skip: !id,
    fetchPolicy: 'cache-and-network',
  });

  return {
    templates: data?.getTicketTemplates || [],
    loading,
    error,
    refetch,
  };
}
